
export default {
  props: {
    current: {
      type: Number,
      required: false,
      default: 1,
    },

    max: {
      type: Number,
      required: false,
      default: 1,
    },

    stock: {
      type: [Number, String],
      required: false,
      default: 0,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      input: this.current,
    };
  },

  watch: {
    // `input` is seeded from `current` at creation only. The saved quantity can
    // arrive later (a cart line resolved after this rendered) or change from
    // elsewhere, and the field would otherwise keep showing whatever it was
    // built with.
    current(value) {
      this.input = value
    },

    hasError(error) {
      if (error) {
        this.$emit("error");
      } else {
        this.$emit("valid");
      }
    },
  },

  computed: {
    // Only render a real max. Besides -1 (unlimited), `max` arrives as NaN
    // whenever the parent is showing the placeholder offer built by
    // ProductBase.setDefaultOffer(), which has no `count` — Number(undefined).
    // That put an invalid max="NaN" in the DOM. Returning null drops the
    // attribute instead. Deliberately does NOT feed canPlus/hasError: those
    // read `max` directly, and a NaN there is what currently keeps +/- inert
    // until specs are chosen.
    getMaxAttr() {
      return Number.isFinite(this.max) && this.max > 0 ? this.max : null;
    },

    getIsUnlimited() {
      return this.max === -1;
    },

    getFormatedStock() {
      return Number(this.stock);
    },

    canMinus() {
      return this.input > 1;
    },

    canPlus() {
      return this.getIsUnlimited ? true : this.input < this.max;
    },

    hasError() {
      return (
        (!this.getIsUnlimited && this.input > this.max) ||
        this.input < 1 ||
        !Number.isInteger(this.input)
      );
    },

    canSave() {
      return this.input !== this.current && !this.hasError;
    },

    getStock() {
      if (this.getFormatedStock > 0) return this.getFormatedStock;

      return this.getIsUnlimited ? "many" : this.max;
    },
  },

  methods: {
    plus() {
      this.input++;
      this.$emit("input", this.input);
      this.$emit("change", this.input);
    },

    minus() {
      this.input--;
      this.$emit("input", this.input);
      this.$emit("change", this.input);
    },

    onInput() {
      this.$emit("input", this.input);
    },

    checkInput() {
      if (this.canSave) {
        this.$emit("change", this.input);
      }
    },
  },
};
